import { bl_cms_calendar_member_hdr_RowClass } from '../../../dbschema/bl_cms_calendar_member_hdr.model';
import {BaseContainerModel} from '../../base-container.model';

export class CmsMemberContainerModel extends BaseContainerModel{
    bl_cms_calendar_member_hdr: bl_cms_calendar_member_hdr_RowClass = new bl_cms_calendar_member_hdr_RowClass();
}